import { Map } from 'immutable';
import { ReduxAction } from 'types/redux.types';
import actions from './actions';

const initState = Map({
  updatePending: false,
});

const serviceWorkerUpdaterReducer = (state = initState, action: ReduxAction) => {
  switch (action.type) {
    case actions.SET_UPDATE_PENDING:
      return state.set('updatePending', action.payload);
    default:
      return state;
  }
};

export default serviceWorkerUpdaterReducer;
